module.exports = __webpack_public_path__ + "static/media/instagram.67e5289a.svg";